export default "__VITE_ASSET__D$861xGx__"